// ------------------------------------------------------------------------------------------
// Utils.ts
// ------------------------------------------------------------------------------------------

/**
 * Captura el Script actual que incluye el loader
 * Busca el script por el atributo data-public-key en lugar del nombre de archivo
 * @returns current_script <HTMLScriptElement>
 */
export const get_current_script = (): HTMLScriptElement | null => {

  // Buscar el script que tiene el atributo data-public-key
  // Este es el script que el usuario incluye en su página
  const current_script = document.querySelector( 'script[data-public-key]' ) as HTMLScriptElement;
  return current_script;
};

/**
 * Obtiene el lang_id con prioridad: URL param ?lang= > data-lang-id > idioma del navegador > 'en'
 * @param script El elemento script actual
 * @returns lang_id (por defecto 'en' si no se puede determinar)
 */
export const get_lang_id = ( script: HTMLScriptElement | null ): string => {

  // Prioridad 1: parámetro GET ?lang= de la URL del host
  try {
    const url_lang = new URLSearchParams( window.location.search ).get( 'lang' );
    if( url_lang && /^[a-z]{2,3}$/.test( url_lang.trim().toLowerCase() ) )
      return url_lang.trim().toLowerCase();
  } catch { /* ignore */ }

  // Prioridad 2: data-lang-id del script
  if( script ) {
    const script_lang = script.dataset.langId || '';
    if( script_lang )
      return script_lang;
  }

  // Prioridad 3: idioma del navegador del visitante ('es-ES' -> 'es'). Sin esto,
  // un embed sin data-lang-id arrancaba SIEMPRE en inglés aunque el visitante
  // (y el contenido del tenant) fueran españoles.
  try {
    const nav = String( ( navigator.languages && navigator.languages[0] ) || navigator.language || '' );
    const primary = nav.trim().toLowerCase().split( '-' )[0];
    if( /^[a-z]{2}$/.test( primary ) )
      return primary;
  } catch { /* ignore */ }

  // Prioridad 4: default
  return 'en';
};

/**
 * Obtiene el show_button del script del loader
 * @param script El elemento script actual
 * @returns show_button (por defecto 'en' si no se especifica)
 */
export const get_show_button = ( script: HTMLScriptElement | null ): string => {
  
  // Si no hay script, retornar 'en' por defecto
  if( !script ) return 'true';
  
  // Capturar el data-lang-id del script, por defecto 'en'
  const show_button = script.dataset.showButton || 'true';
  
  return show_button;
};